import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Col, Modal, Row } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
//import Concursopublico from "../../../assets/img/admin/Concursopublico.jpg";
import { ReactComponent as MesaTrabajo } from "../../../assets/img/home/mesa-trabajo.svg";
import { ReactComponent as ImgFecha } from "../../../assets/img/home/fecha.svg";
import { linksRouter } from "../../../config/RouterLink";
import { getHisAcademicoById } from "../../../redux/aspirante/reqAcademicoDuck";
import { Preguntas } from "../../../components/Public/Home/Preguntas";
import ReactGA from "react-ga";

import {
  INFO_REGISTRO,
  INFO_REGISTRO_MODAL,
  INFO_UPD_PASSWORD,
} from "../../../utils";

/**Estilos CSS */
import "../../../assets/css/Home.css";
import "./HomePageAdmin.css";
import { CheckCircleFilled } from "@ant-design/icons";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
} from "../../../redux/consultavacantes/sistemasDucks";

import {
  asignarSistema,
  asignarConcurso,
  asignarConvocatoria,
  nameConcurso,
  nameConvocatoria,
  limpiarDatos,
} from "../../../redux/consultavacantes/consultaVacantesDucks";

import {
  cleanFunciones,
  cleanRequisitosINE,
  cleanObjetivosINE,
  cleanFuncionesINE,
  cleanRequisitos,
  cleanObjetivos,
} from "../../../redux/consultavacantes/descripcionpuestoDucks";
import { setTabAspirante } from "../../../redux/aspirante/aspiranteDucks";
import { withRouter } from "react-router-dom";

import { getValorParametro } from "../../../redux/aspirante/catalogoDucks";
import { FECHA_LIM_REGISTRO } from "../../../utils";

/**
 * Page del Home principal del aspirante cuando inicia sesión
 * @returns JSX.Element
 */
const HomePageAdmin = (props) => {
  const { location } = props;
  const { sistemaINE, sistemaOPLE, materialesINE, materialesOPLE } =
    useSelector((state) => state.sistemas);

  const dispatch = useDispatch();
  const history = useHistory();
  const { existenDatos } = useSelector((state) => state.reqAcademico);
  const [isActiveModal, setIsActiveModal] = useState(
    true || existenDatos || !!location.state?.register
  );
  //|| !!location.state?.register

  const [fecha, setFecha] = useState("");

  useEffect(() => {
    //Se valida que haya registros en req académicos
    dispatch(getHisAcademicoById());

    dispatch(getValorParametro(FECHA_LIM_REGISTRO)).then(({ data }) => {
      setFecha(data.valorConfig);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
  }, [dispatch]);

  //Se limpia el state de Consulta Vacantes
  useEffect(() => {
    return () => {
      dispatch(limpiarDatos());
      dispatch(cleanObjetivos({}));
      dispatch(cleanFunciones({}));
      dispatch(cleanRequisitos({}));
      dispatch(cleanObjetivosINE({}));
      dispatch(cleanFuncionesINE({}));
      dispatch(cleanRequisitosINE({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeModal = () => {
    dispatch(setTabAspirante("2"));
    history.push(linksRouter.datosAspirante);
  };

  const seleccionarConvocatoriaINE = (item) => {
    dispatch(obtenerSistemaINE(item));
    dispatch(asignarSistema(sistemaINE?.idSistema));
    dispatch(asignarConcurso(sistemaINE?.idConcurso));
    dispatch(asignarConvocatoria(sistemaINE?.idConvocatoria));
    dispatch(nameConcurso(sistemaINE?.nombreConcurso));
    dispatch(nameConvocatoria(sistemaINE?.nombreConvocatoria));
    history.push(linksRouter.vacanteslogin);
  };

  const seleccionarConvocatoriaOPLE = (item) => {
    dispatch(obtenerSistemaOPLE(item));
    dispatch(asignarSistema(sistemaOPLE?.idSistema));
    dispatch(asignarConcurso(sistemaOPLE?.idConcurso));
    dispatch(asignarConvocatoria(sistemaOPLE?.idConvocatoria));
    dispatch(nameConcurso(sistemaOPLE?.nombreConcurso));
    dispatch(nameConvocatoria(sistemaOPLE?.nombreConvocatoria));
    history.push(linksRouter.vacanteslogin);
  };

  useEffect(() => {
    ReactGA.initialize("UA-39814429-36");
    ReactGA.pageview("Ingreso al sistema");
  }, []);

  return (
    <>
      <div className="layout-content-public containerHomePageAdmin">
        <div>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={24}>
              <div className="titulo">Información General</div>
            </Col>
          </Row>
        </div>
        <div style={{ marginBottom: "10px" }}>
          <Row gutter={[24, 16]} className="rellenaHeight">
            <Col
              xxl={16}
              xl={16}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="containerConvocatorias"
            >
              <div className="card-menu-home">
                <Row>
                  <Col xxl={16} xl={16} lg={24} md={24} sm={24} xs={24}>
                    <div className="titulo">Convocatorias</div>
                    {/* <div className="subtitulo">
                                        Antes de registrarte y postularte...
                                    </div> */}
                    <div className="descripcion">
                      Consulta las plazas vacantes de las Convocatorias de
                      ingreso para ocupar plazas vacantes en cargos y puestos
                      del Servicio Profesional Electoral Nacional del sistema
                      del Instituto Nacional Electoral <b>(SPEN)</b>.
                    </div>
                    <div style={{ marginTop: "8%" }}>
                      <div>
                        {sistemaINE !== undefined && (
                          <Button
                            className="btn-convocatoria"
                            type="primary"
                            htmlType="submit"
                            onClick={seleccionarConvocatoriaINE}
                          >
                            {sistemaINE?.nombreConvocatoria}
                          </Button>
                        )}
                      </div>
                      <div style={{ marginTop: "4%" }}>
                        {sistemaOPLE !== undefined && (
                          <Button
                            className="btn-convocatoria"
                            type="primary"
                            htmlType="submit"
                            onClick={seleccionarConvocatoriaOPLE}
                          >
                            {sistemaOPLE?.nombreConvocatoria}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col xxl={8} xl={8} lg={0} md={0} sm={0} xs={0}>
                    <MesaTrabajo />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col
              xxl={8}
              xl={8}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="containerFecha"
            >
              <div className="card-menu-home">
                <Row align="middle" gutter={24}>
                  <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={24}>
                    <ImgFecha />
                  </Col>
                  <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={24}>
                    <div className="titulo text-center">
                      Fecha límite de registro
                    </div>
                    <div className="fecha text-center">{fecha && fecha}</div>
                  </Col>
                </Row>
                {/* <div className="fecha text-center">
                                {fecha && fecha}
                            </div> */}
                <div style={{ marginTop: 10 }}>
                  <div className="descripcion">
                    La seguridad de tus datos es importante para nosotros.
                  </div>
                  <br />
                  {materialesINE?.activoConfiguracion === 1 && (
                    <Link to={linksRouter.avisoPrivacidadINEAdmin} className="link">
                      Aviso de privacidad INE
                    </Link>
                  )}
                  <br />
                  {materialesOPLE?.activoConfiguracion === 1 && (
                    <Link to={linksRouter.avisoPrivacidadOPLEAdmin} className="link">
                      Aviso de privacidad OPLE
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <Row gutter={[24, 16]} className="sectionMenu rellenaHeight">
            <Col xxl={16} xl={16} lg={24} md={24} sm={24} xs={24}>
              <div>
                <Preguntas />
              </div>
            </Col>
            <Col
              xxl={8}
              xl={8}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className="containerAyuda"
            >
              <div className="card-menu-home">
                <div className="titulo text-center">
                  Te brindamos mayor ayuda en tu proceso
                </div>
                <div className="subtitulo text-center">
                  Conoce la normativa, los documentos y materiales de apoyo
                </div>
                {materialesINE !== null &&
                materialesINE !== undefined &&
                materialesINE.activoConfiguracion === 1 ? (
                  <div style={{ marginTop: 25 }}>
                    <Button
                      type="default"
                      className="btn-material_apoyo"
                      block
                      href={
                        materialesINE !== null &&
                        materialesINE.valorConfiguracion
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Concurso Público del sistema INE <ExportOutlined />
                    </Button>
                  </div>
                ) : (
                  <div style={{ marginTop: 25 }}></div>
                )}

                {materialesOPLE !== null &&
                materialesOPLE !== undefined &&
                materialesOPLE.activoConfiguracion === 1 ? (
                  <div style={{ marginTop: 25 }}>
                    <Button
                      type="default"
                      className="btn-material_apoyo"
                      block
                      href={
                        materialesOPLE !== null &&
                        materialesOPLE.valorConfiguracion
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Concurso Público del sistema OPLE <ExportOutlined />
                    </Button>
                  </div>
                ) : (
                  <div style={{ marginTop: 25 }}></div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {/*  <div className="homePageBackGroud">
        <Row className="container-title-home">
          <Col
            className="container-title-home-separate"
            xs={{ offset: 1, span: 23 }}
            
          >
            <div className="title-home">Concursos Públicos de ingreso para ocupar plazas vacantes en cargos y puestos del Servicio Profesional Electoral Nacional</div>
            <div className="subtitle-home">Te damos la bienvenida</div>
            <div className="text-home">
              Este sistema te permite iniciar el registro a un Concurso Público,
              para
              <br />
              ocupar cargos y puestos del Servicio Profesional Electoral
              Nacional
            </div>
          </Col>
        </Row>
        <Row style={{ paddingBottom: "10px" }}>
          <Col
            xs={{ offset: 1, span: 23 }}
            md={{ offset: 1, span: 18 }}
            lg={{ offset: 1, span: 12 }}
            xl={{ offset: 1, span: 6 }}
          >
            {sistemaINE !== undefined && (
              <Button
                className="button-home"
                type="primary"
                htmlType="submit"
                onClick={seleccionarConvocatoriaINE}
              >
                {sistemaINE?.nombreConvocatoria}
              </Button>
            )}
          </Col>
        </Row>
        <Row>
          <Col
            xs={{ offset: 1, span: 23 }}
            md={{ offset: 1, span: 18 }}
            lg={{ offset: 1, span: 12 }}
            xl={{ offset: 1, span: 6 }}
          >
            {sistemaOPLE !== undefined && (
              <Button
                className="button-home"
                type="primary"
                htmlType="submit"
                onClick={seleccionarConvocatoriaOPLE}
              >
                {sistemaOPLE?.nombreConvocatoria}
              </Button>
            )}
          </Col>
        </Row>
        <Row className="containerPreguntas">
          <Col>
            <Preguntas />
          </Col>
        </Row>
      </div> */}

      <Modal
        title={
          <>
            <CheckCircleFilled style={{ color: "#d5007f" }} />

            {location.state?.update
              ? "Actualización exitosa de contraseña"
              : INFO_REGISTRO}
          </>
        }
        visible={!isActiveModal}
        onCancel={() => {
          setIsActiveModal((state) => !state);
        }}
        keyboard={false}
        maskClosable={false}
        width={400}
        footer={[
          <center key="registro">
            <Button type="primary" onClick={onChangeModal}>
              Continuar con el registro
            </Button>
          </center>,
        ]}
      >
        <div className="justificar">
          IMPORTANTE <br />
          {location.state?.update ? INFO_UPD_PASSWORD : INFO_REGISTRO_MODAL}
        </div>
      </Modal>
    </>
  );
};

export default withRouter(HomePageAdmin);
